import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {FormControl} from "@material-ui/core";
import {withStyles} from "@material-ui/core/styles";
import FieldWrapper from "../../FieldWrapper";
import SelectType from '../SelectType/Select';
import findByString from "../../Utils/getValueByString";
import FieldErrorMessage from "../../Utils/errorMessage";
import {errorHandler} from "../../Utils/errorHandler";
import {setArrayPath} from "../../Utils/setArrayPath";
import {checkHidden} from "../../Utils/checkHidden";
import {checkEvents} from "../../Utils/checkEvents";
import ArrayField from "./ArrayField";
import SimpleField from "./SimpleField";
import {getParamsFromString} from "../../../../../Components/JsonScreen/Utils";
import request from "../../../../../Services/API/Requests";

const styles = () => ({
    formControl: {
        minWidth: 'auto'
    },
});

class DefaultType extends Component {
    constructor(props) {
        super(props);
        this.fieldRef = React.createRef();
        this.state = {
            values: {},
            initialValue: '',
            fieldValue: '',
            filterValue: '',
            errorComponent: false,
            changed: false,
            freeSolo: false,
            error: '',
            path: '',
            events: {
                onChange: null,
                onBlur: null,
                onReturnValue: null
            },
            helpText: null
        }
    }

    componentDidMount() {
        const {onBlurFromCell, field, focusNow, events, errors, containerArrayPath} = this.props;
        if (events.length) {
            this.setEvents();
        }
        if (focusNow && field.disabled) {
            onBlurFromCell();
        }
        if (focusNow) {
            if (this.fieldRef.current) {
                this.fieldRef.current.focus()
            }
        }
        if (field.helpText) {
            const getHelpText = async () => {
                try {
                    const res = await request({
                        url: 'helpText/read',
                        data: {id: field.helpText}
                    });
                    this.setState({helpText: res})
                } catch (e) {
                    console.log('get help text error', e)
                }
            }

            getHelpText();
        }
        if (errors) {
            let errorField = errorHandler(errors, field.path, containerArrayPath);
            if (errorField) {
                this.setState({error: errorField})
            }

            if(!errorField && this.state.error) {
                this.setState({error: false})
            }
        }
        this.setValues();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const {values, errors, field: {path}, containerArrayPath} = this.props;
        const {values: prevValues, errors: prevErrors, field: {path: prevPath}} = prevProps;
        const arrayPath = setArrayPath(path, containerArrayPath);
        const prevValue = findByString(prevValues, arrayPath ? arrayPath : path);
        const value = findByString(values, arrayPath ? arrayPath : path);

        if (value !== prevValue) {
            this.setValues();
        }
        if (errors !== prevErrors) {
            this.setErrors()
        }
        if (path !== prevPath) {
            this.setValues();
        }
    }

    componentDidCatch(error, errorInfo) {
        this.setState({errorComponent: true});
        console.log(error, errorInfo)
    }

    setEvents = () => {
        const {events} = this.props;
        const currentEvents = checkEvents(events);
        this.setState({events: currentEvents})
    };
    setValues = () => {
        const {
            values,
            field: {path, isArray},
            containerArrayPath,
            globalValues,
            actionsContext,
            screenName
        } = this.props;
        try {
            const executedPath = getParamsFromString(path, {...globalValues, ...actionsContext}, screenName);
            let arrayPath = setArrayPath(executedPath, containerArrayPath);
            let value = findByString(values, arrayPath ? arrayPath : executedPath);
            let currentValue = isArray ? value ? value : [] : value !== undefined ? value : '';

            if (isArray) {
                let isArrayValue = Array.isArray(value);

                if (value && isArrayValue) {
                    currentValue = value;
                }

                //transform string value to array
                if (value && typeof value === "string") {
                    currentValue = [value]
                }

                if (!value) {
                    currentValue = [];
                }

            } else {
                currentValue = value !== undefined ? value : '';
            }

            this.setState({
                values,
                initialValue: currentValue,
                fieldValue: currentValue,
                path: arrayPath ? arrayPath : executedPath
            })
        } catch (e) {
            console.log(e)
        }
    };
    setErrors = () => {
        const {path} = this.state;
        const {errors, containerArrayPath} = this.props;
        let errorField = errorHandler(errors, path, containerArrayPath);
        if (errorField) {
            this.setState({error: errorField})
        }

        if(!errorField && this.state.error) {
            this.setState({error: false})
        }

    };

    onChangeArray = (value) => {
        const {path} = this.state;
        const {setValue, field: {trackChange}} = this.props;
        this.setState({fieldValue: value, changed: true})
        setValue(value, path, trackChange)
    }

    //simple handlers
    onChange = (event) => {
        const {events, path} = this.state;
        const {
            setValue,
            setValueOnChange,
            field: {trackChange, setValueOnChange: propSetValueOnChange, valueDropdownOnly},
            doActions
        } = this.props;
        if (valueDropdownOnly) return;
        const {value} = event.target;
        if (events.onChange) {
            doActions(events.onChange, {currentField: {value}})
        }
        if (setValueOnChange || propSetValueOnChange) {
            setValue(value, path, trackChange)
        }
        this.setState({fieldValue: value, filterValue: value, changed: !setValueOnChange})
    };
    onChangeFilterValue = (v) => {
        this.setState({filterValue: v});
    }
    onChangeFromDropDown = (value) => {
        const {field: {isArray, trackChange}, setValueOnChange, setValue, doActions} = this.props;
        const {fieldValue, events, path} = this.state;
        if (isArray) {
            const isExists = fieldValue.find(v => v === value);
            let newV =
                //if value is array, use value as final value
                Array.isArray(value) ? value :
                    //if exists value , remove the value from array
                    isExists ? fieldValue.filter(v => v !== value) :
                        [...fieldValue, {value: value, idx: `${value}_${fieldValue.length + 1}`}]

            this.setState(state => ({
                fieldValue: newV,
                filterValue: '',
                changed: true,
            }), () => {
                if (setValueOnChange) {
                    let concatValues = [...fieldValue, value];
                    setValue(concatValues, path, trackChange, true);
                    return
                }
                if (events.onChange) {
                    doActions(events.onChange, {currentField: {value}})
                }
                this.onBlur();
            });

        } else {
            if (events.onReturnValue) {
                doActions(
                    events.onReturnValue,
                    {
                        currentComponent: {path, value: fieldValue, newValue: value}
                    }
                );
                return
            }
            if (events.onChange) {
                doActions(events.onChange, {currentField: {value}})
            }
            if (setValueOnChange) {
                setValue(value, path, trackChange, true);
                return
            }
            this.setState({fieldValue: value, filterValue: '', changed: true}, () => {
                this.onBlur();
            });

        }
    };
    setInitialValue = () => {
        this.setState(state => ({fieldValue: state.initialValue, changed: false}))
    };

    onBlur = (e) => {
        const {fieldValue, changed, path, events, filterValue} = this.state;
        const {
            field: {isArray, trackChange, setValueOnChange: propSetValueOnChange},
            setValue,
            onBlurFromCell,
            focusNow,
            setValueOnChange,
            doActions,
            actionsContext,
            onBlur
        } = this.props;

        if (propSetValueOnChange || setValueOnChange) return;
        if (changed) {
            let currentValue = isArray ?
                (filterValue.length ? [...fieldValue, {value: filterValue}] : fieldValue).map(v => {
                    return v.value ? v.value : v
                }) : fieldValue;
            isArray && filterValue && this.setState({filterValue: ""});
            setValue(currentValue, path, trackChange)
        }
        if (focusNow) {
            onBlurFromCell();
        }

        if (onBlur) onBlur(e)

        if (events.onBlur) {
            doActions(events.onBlur, {...actionsContext, currentField: {value: fieldValue}})
        }

        this.setState({changed: false})
    };


    setFreeSolo = (state) => {
        this.setState({freeSolo: state})
    };

    render() {
        const {
            classes,
            field: {
                isArray, disabled, hideCondition, values: optValues,
                type, pattern, min, max, minLength, maxLength,
                label, decimalPlaces, required, autofocus, dropdown, dropdownContext, multiLanguage,
                autocomplete, patternTitle, placeholder, valueDropdownOnly, endAdornment, startAdornment,
                disableKeydown
            },
            field, events, doActions, fieldStyles, labelStyles,
            showLabel, goBack, setValue, errors = [], focusNow,
            onBlurFromCell, history, containerArrayPath, isMobile,
            globalValues,
            customRef, actionsContext, onKeyDown, id, screenName
        } = this.props;
        const fieldRef = customRef ? customRef : this.fieldRef;
        const {errorComponent, values, fieldValue, filterValue, changed, error, path, helpText} = this.state;
        const isHidden = checkHidden({...globalValues, ...actionsContext}, hideCondition, screenName);
        const isDisabled = checkHidden({...globalValues, ...actionsContext}, disabled, screenName);
        const dropdownContextValue = getParamsFromString(dropdownContext, globalValues, screenName)
        const fieldPresentation = fieldStyles.presentation ?
            fieldStyles.presentation === 'inlineWithLabel' ? 'standard' :
                fieldStyles.presentation === 'stackLabel' ? 'outlined' :
                    fieldStyles.presentation : 'outlined'
        return (
            !errorComponent ? (
                <FieldWrapper
                    required={required}
                    dropdown={dropdown}
                    focusNow={focusNow}
                    record={this.props.values}
                    filterValue={filterValue}
                    path={path}
                    disabled={isDisabled}
                    changed={changed}
                    setValue={this.onChangeFromDropDown}
                    setInitialValue={this.setInitialValue}
                    fieldRef={fieldRef}
                    fieldStyles={fieldStyles}
                    labelStyles={labelStyles}
                    showLabel={showLabel}
                    label={label}
                    goBack={goBack}
                    history={history}
                    setFreeSolo={this.setFreeSolo}
                    isMobile={isMobile}
                    isHidden={isHidden}
                    helpText={helpText}
                    globalValues={globalValues}
                    screenName={screenName}
                    dropdownContext={dropdownContextValue}
                    fieldValue={fieldValue}
                >
                    <FormControl classes={{root: classes.formControl}}
                                 style={{width: fieldStyles.fullWidth ? '100%' : fieldStyles.width}}
                                 fullWidth={isMobile ? true : fieldStyles.fullWidth}>
                        {optValues ? (
                            <SelectType
                                field={field}
                                setValue={setValue}
                                errors={errors}
                                goBack={goBack}
                                values={values}
                                fieldStyles={fieldStyles}
                                labelStyles={labelStyles}
                                showLabel={true}
                                focusNow={focusNow}
                                onBlurFromCell={onBlurFromCell}
                                containerArrayPath={containerArrayPath}
                                label={label}
                                isMobile={isMobile}
                                events={events}
                                doActions={doActions}
                                fieldPresentation={fieldPresentation}
                                actionsContext={actionsContext}
                                globalValues={globalValues}
                                screenName={screenName}
                                ignoreError={true}
                            />
                        ) : isArray ? (
                            <ArrayField
                                fieldValue={fieldValue}
                                filterValue={filterValue}
                                onChangeFilterValue={this.onChangeFilterValue}
                                error={error}
                                errors={errors}
                                disabled={isDisabled}
                                min={min}
                                max={max}
                                minLength={minLength}
                                maxLength={maxLength}
                                pattern={pattern}
                                required={isHidden ? false : required}
                                type={type}
                                onChangeArray={this.onChangeArray}
                                onBlur={this.onBlur}
                                fieldStyles={fieldStyles}
                                fieldRef={fieldRef}
                                classes={classes}
                                field={field}
                                multiLanguage={multiLanguage}
                                autofocus={autofocus}
                                freeSolo={this.state.freeSolo}
                                path={path}
                                label={label}
                                isMobile={isMobile}
                                fieldPresentation={fieldPresentation}
                                placeholder={placeholder}
                                doActions={doActions}
                                events={events}
                            />
                        ) : (
                            <SimpleField
                                fieldValue={fieldValue}
                                error={error}
                                disabled={isDisabled}
                                min={min}
                                max={max}
                                minLength={minLength}
                                maxLength={maxLength}
                                pattern={pattern}
                                patternTitle={patternTitle}
                                type={type}
                                onChange={this.onChange}
                                onBlur={this.onBlur}
                                fieldStyles={fieldStyles}
                                fieldRef={fieldRef}
                                autofocus={autofocus}
                                required={required}
                                decimalPlaces={decimalPlaces}
                                label={label}
                                isMobile={isMobile}
                                classes={classes}
                                multiLanguage={multiLanguage}
                                autocomplete={autocomplete}
                                fieldPresentation={fieldPresentation}
                                placeholder={placeholder}
                                onKeyDown={onKeyDown}
                                valueDropdownOnly={valueDropdownOnly}
                                id={id}
                                field={field}
                                dropdown={dropdown}
                                endAdornment={endAdornment}
                                startAdornment={startAdornment}
                                screenName={screenName}
                                path={path}
                                disableKeydown={disableKeydown}
                                doActions={doActions}
                                events={events}
                            />
                        )}
                        <FieldErrorMessage message={error}/>
                    </FormControl>
                </FieldWrapper>
            ) : (
                <span>Something bad with field</span>
            )
        );
    }

}

DefaultType.propTypes = {
    errors: PropTypes.array,
    //the object of field
    field: PropTypes.shape({
        label: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
        path: PropTypes.string,
        autofocus: PropTypes.bool,
        isArray: PropTypes.bool,
        required: PropTypes.bool,
        values: PropTypes.array,
        pattern: PropTypes.string,
        min: PropTypes.string,
        max: PropTypes.string,
        minLength: PropTypes.string,
        maxLength: PropTypes.string,
        dropdown: PropTypes.string,
        dropdownContext: PropTypes.string, //js script
        valueDropdownOnly: PropTypes.bool,
        type: PropTypes.oneOf(['number', 'integer', 'date', 'datetime-local', 'string', 'password'])
    }).isRequired,
    fieldStyles: PropTypes.shape({
        presentation: PropTypes.oneOf(['standard', 'outlined', 'inlineWithLabel']),
        fullWidth: PropTypes.bool,
        margin: PropTypes.string,
        withoutStyles: PropTypes.bool,
        hideLabel: PropTypes.bool
    }),
    labelStyles: PropTypes.shape({
        width: PropTypes.string,
        margin: PropTypes.string,
    }),
    onKeyDown: PropTypes.func,
    events: PropTypes.array,
    values: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    setValue: PropTypes.func.isRequired,
    showLabel: PropTypes.bool,
    //for table fields
    focusNow: PropTypes.bool,
    onBlurFromCell: PropTypes.func,
    globalValues: PropTypes.object,
    id: PropTypes.string,
};

DefaultType.defaultProps = {
    errors: [],
    events: [],
    goBack: () => {
    },
    setValue: () => {
    },
    onKeyDown: () => {
    },
    values: {},
    labelStyles: {},
    fieldStyles: {}
};

export default withStyles(styles)(DefaultType);